import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SidebarRefService } from '@shared/services/sidebar-ref.service';
import { NGXLogger } from 'ngx-logger';
import { EMPTY, catchError, map, of, switchMap, tap } from 'rxjs';

import { shelfAction } from './shelf.actions';
import { ShelfService } from '../service/shelf.service';

@Injectable()
export class ShelfEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private shelfService: ShelfService,
    private sideBarRefService: SidebarRefService
  ) {}

  shelfListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfAction.shelfListRequest),
      tap((_) => this.logger.debug('@Effect [Shelf] shelf list request ')),
      switchMap(({ payload }) => {
        return this.shelfService.list({ ...payload }).pipe(
          map((response) => {
            return shelfAction.shelfListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  shelfSequenceListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfAction.shelfSequenceListRequest),
      tap((_) => this.logger.debug('@Effect [Shelf] shelf sequence list request ')),
      switchMap(({ payload }) => {
        return this.shelfService.sequenceList({ ...payload }).pipe(
          map((response) => {
            return shelfAction.shelfSequenceListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  shelfSequenceSubmitRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfAction.shelfSequenceSubmitRequest),
      tap(() => this.logger.debug('@Effect [Shelf] shelf sequence submit request')),
      switchMap(({ payload }) => {
        return this.shelfService.shelfSequenceSubmit(payload).pipe(
          map((_) => {
            return shelfAction.shelfSequenceSubmitResponse({ response: true });
          }),
          catchError((err) => (err.error?.code === '00003' ? this.sideBarRefService.openHandleVersionError() : EMPTY))
        );
      })
    );
  });

  shelfBarcodePrintListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfAction.shelfBarcodePrintListRequest),
      tap((_) => this.logger.debug('@Effect [Shelf] shelf barcode print list request')),
      switchMap(({ payload }) => {
        return this.shelfService.getShelfBarcodePrintList({ ...payload }).pipe(
          map((response) => {
            return shelfAction.shelfBarcodePrintListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
